<template>
  <div class="w-100">
    <div class="row m-0 px-0 pt-3 pb-1 p-md-3 align-items-center justify-content-center font_dark_medium">
      <div class="col px-1 text-center d-none d-md-flex">
        FILTER
      </div>
      <div class="col px-1">
        <select class="custom-select form-control font_light" id="team" v-model="team" @change="filterBy">
          <option value="" key="none" selected class="lighter">Team</option>
          <option :value="team.name" v-for="(team) in teams" :key="team.name">{{team.name}}</option>
        </select>
      </div>
      <div class="col px-1">
        <select class="custom-select form-control font_light" id="date" v-model="date" @change="filterBy">
          <option value="" key="none" selected class="lighter">Date</option>
          <option :value="date.date" v-for="(date) in dates" :key="date.date">{{date.date | dateFormat}}</option>
        </select>
      </div>
      <div class="col px-1">
        <select class="custom-select form-control font_light" id="pool" v-model="pool" @change="filterBy">
          <option value="" key="none" selected class="lighter">Pool</option>
          <option :value="pool.name" v-for="(pool) in pools" :key="pool.name">{{pool.name}}</option>
        </select>
      </div>
      <div class="col px-1 text-right" @click="clearFilter">
        <div class="btn btn-outline font_light">
          Clear <span class="d-none d-md-inline">Filter</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'PredictionFilter',
  props: ['games'],
  data: function () {
    return {
      team: '',
      teams: [
        { 'name': 'Argentina' },
        { 'name': 'Australia' },
        { 'name': 'Canada' },
        { 'name': 'England' },
        { 'name': 'Fiji' },
        { 'name': 'France' },
        { 'name': 'Georgia' },
        { 'name': 'Ireland' },
        { 'name': 'Italy' },
        { 'name': 'Japan' },
        { 'name': 'Namibia' },
        { 'name': 'New Zealand' },
        { 'name': 'Russia' },
        { 'name': 'Samoa' },
        { 'name': 'Scotland' },
        { 'name': 'South Africa' },
        { 'name': 'Tonga' },
        { 'name': 'Uruguay' },
        { 'name': 'USA' },
        { 'name': 'Wales' }
      ],
      pool: '',
      pools: [
        { 'name': 'A' },
        { 'name': 'B' },
        { 'name': 'C' },
        { 'name': 'D' },
        { 'name': 'QF' },
        { 'name': 'SF' },
        { 'name': 'F' }
      ],
      date: '',
      dates: [
        { 'date': '2019-09-20T00:00:00Z' },
        { 'date': '2019-09-21T00:00:00Z' },
        { 'date': '2019-09-22T00:00:00Z' },
        { 'date': '2019-09-23T00:00:00Z' },
        { 'date': '2019-09-24T00:00:00Z' },
        { 'date': '2019-09-25T00:00:00Z' },
        { 'date': '2019-09-26T00:00:00Z' },
        { 'date': '2019-09-28T00:00:00Z' },
        { 'date': '2019-09-29T00:00:00Z' },
        { 'date': '2019-09-30T00:00:00Z' },
        { 'date': '2019-10-02T00:00:00Z' },
        { 'date': '2019-10-03T00:00:00Z' },
        { 'date': '2019-10-04T00:00:00Z' },
        { 'date': '2019-10-05T00:00:00Z' },
        { 'date': '2019-10-06T00:00:00Z' },
        { 'date': '2019-10-08T00:00:00Z' },
        { 'date': '2019-10-09T00:00:00Z' },
        { 'date': '2019-10-11T00:00:00Z' },
        { 'date': '2019-10-12T00:00:00Z' },
        { 'date': '2019-10-13T00:00:00Z' }
      ],
      filterItems: {
        'team': '',
        'date': '',
        'pool': ''
      }
    }
  },
  filters: {
    dateFormat (val) {
      // console.log("2019-10-13T00:00:00Z")
      return moment(val).format('DD MMMM')
    }
  },
  methods: {
    filterBy () {
      this.filterItems.team = this.team
      this.filterItems.pool = this.pool
      this.filterItems.date = this.date
      this.$emit('input', this.filterItems)
    },
    clearFilter () {
      this.team = ''
      this.pool = ''
      this.date = ''
      this.filterItems.team = this.team
      this.filterItems.pool = this.pool
      this.filterItems.date = this.date
      this.$emit('input', this.filterItems)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.white_card {
  background: #ffffff;
  border-radius: 5px;
}
/* .custom-select {
  border-radius: 0;
  background: url(../assets/images/select_bg.png);
  background-size: cover;
  padding-right: 0;
  color: #ffffff;
} */
.custom-select {
  border-radius: 4px;
  /* padding-right: 0; */
  color: #ffffff;
  border: none;
  height:30px;
  padding: 0 1.5rem 0 0.5rem;
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  background: url(../assets/images/chev.png) no-repeat right 0.5rem center/10px 6px;
  background-color: #0a5668;
}
.btn-outline {
  background: transparent;
  border: 1px solid #ffffff;
  color: #ffffff;
  height: 30px;
  padding: 0.375rem 1rem;
  font-size: 14px;
  line-height: 1;
}
</style>
